import { z } from 'zod/v4';

/**
 * Social network / messenger identifier, mirroring the full `ESocialNetworks`
 * enum from the host app. Shared by the social widget's items and the form
 * widget's chat-bot bag (originally authored there and promoted here when the
 * social widget needed it). Individual widgets only offer subsets in their
 * UI, but the schema accepts the full host enum so persisted data with
 * retired networks (`vk`, `ok`, `yandexzen`) parses too.
 */
export const socialNetworkSchema = z.enum([
    'facebook',
    'twitter',
    'instagram',
    'youtube',
    'telegram',
    'snapchat',
    'vk',
    'ok',
    'viber',
    'linkedin',
    'pinterest',
    'vimeo',
    'slideshare',
    'tumblr',
    'medium',
    'tiktok',
    'yandexzen',
    'whatsapp',
    'spotify',
    'twitch',
    'messenger',
    'skype',
    'onlyfans',
    'patreon',
    'buymeacoffee',
    'soundcloud',
    'threads',
    'linktree',
    'deviantart',
    'artstation',
    'email',
    'phone',
]);

/**
 * Icon style variant, mirroring `EIconType` — selects the asset directory the
 * host apps load the per-network SVGs from. Shared by the social widget and
 * the form widget's chat-bot bag.
 */
export const socialIconTypeSchema = z.enum([
    'logos',
    'round',
    'square',
    'flat',
    'grey',
    'outlined',
    'outlined_white',
    'white',
]);
